import styled from 'styled-components';
import boxShadow from '../../configs/boxShadow';

const Wrapper = styled.div`
  margin-top: 24px;
  background-color: white;
  border-radius: 12px;
  padding: ${(props) => {
    return props.isTable ? '16px 24px' : '32px 40px';
  }};
  box-shadow: ${boxShadow.normal};
`;

export default Wrapper;
